import types from './types';

const INITIAL_STATE = {
  isFetchingFileTypes: false,
  isFetchingServer: false,
  isFetchingCompanies: false,

  result: [],
};

const parameterReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_FILE_TYPES_REQUEST:
        return {
            ...state,
            result: [],
            isFetchingFileTypes: true,
        };

    case types.GET_FILE_TYPES_SUCCESS:
        return {
            ...state,
            result: action.payload,
            isFetchingFileTypes: false,
        };

    case types.GET_FILE_TYPES_FAILURE:
        return {
            ...state,
            result: [],
            isFetchingFileTypes: false,
        };

    case types.GET_SERVER_REQUEST:
        return {
            ...state,
            result: [],
            isFetchingServer: true,
        };

    case types.GET_SERVER_SUCCESS:
        return {
            ...state,
            result: action.payload,
            isFetchingServer: false,
        };

    case types.GET_SERVER_FAILURE:
        return {
            ...state,
            result: [],
            isFetchingServer: false,
        };

    case types.GET_COMPANIES_REQUEST:
        return {
            ...state,
            result: [],
            isFetchingCompanies: true,
        };

    case types.GET_COMPANIES_SUCCESS:
        return {
            ...state,
            result: action.payload,
            isFetchingCompanies: false,
        };

    case types.GET_COMPANIES_FAILURE:
        return {
            ...state,
            result: [],
            isFetchingCompanies: false,
        };

    default:
      return state;
  }
};

export default parameterReducer;
